// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");

function ShareDialog(props) {
  var mode = props.mode;
  var user = props.user;
  var match = React.useState(function (param) {
        return false;
      });
  var setLoading = match[1];
  var match$1 = React.useState(function (param) {
        
      });
  var setLink = match$1[1];
  var link = match$1[0];
  var userId = User$ReactHooksTemplate.id(user);
  var fetchLink = function (param) {
    Curry._1(setLoading, (function (param) {
            return true;
          }));
    var endpoint = mode === "confirmation" ? "/api/v1/users/" + String(userId) + "/generate_confirmation_link" : "/api/v1/users/" + String(userId) + "/generate_reset_password_link";
    Js_promise.$$catch((function (_err) {
            console.log("Failed to generate link");
            Curry._1(setLoading, (function (param) {
                    return false;
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var key = mode === "confirmation" ? "confirmation_url" : "reset_password_url";
                var url = Json_decode.field(key, Json_decode.string, response);
                Curry._1(setLink, (function (param) {
                        return url;
                      }));
                Curry._1(setLoading, (function (param) {
                        return false;
                      }));
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostJSON(endpoint, {})));
  };
  React.useEffect((function (param) {
          fetchLink();
        }), [
        user,
        mode
      ]);
  var tmp = mode === "confirmation" ? "User Confirmation Link" : "Password Reset Link";
  var tmp$1 = mode === "confirmation" ? "Copy or share this link to confirm the user's account." : "Copy or share this secure link with the user for password reset.";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx("img", {
                                  className: "h-4 w-4 cursor-pointer",
                                  src: Image$ReactHooksTemplate.closeIcon
                                }),
                            className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none",
                            onClick: props.onClose
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("span", {
                                          children: "🔗",
                                          className: "text-2xl"
                                        }),
                                    className: "w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("h2", {
                                            children: tmp,
                                            className: "text-2xl font-semibold text-gray-900"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: tmp$1,
                                            className: "text-sm text-gray-600 mt-1 leading-snug max-w-md mx-auto"
                                          })
                                    ]
                                  })
                            ],
                            className: "flex flex-col items-center mb-6 space-y-3"
                          }),
                      match[0] ? JsxRuntime.jsx("p", {
                              children: "Generating link...",
                              className: "text-gray-600 text-center py-6"
                            }) : (
                          link !== undefined ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("p", {
                                                  children: "Generated link:",
                                                  className: "text-sm text-gray-700 mb-2 font-medium"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: link,
                                                  className: "text-sm text-gray-900 bg-white border border-gray-300 rounded-lg px-3 py-2 break-all"
                                                })
                                          ],
                                          className: "bg-gray-50 border border-gray-200 rounded-lg p-5 mb-6 text-left"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("button", {
                                                children: "Copy Link",
                                                className: "px-6 py-2 text-sm font-medium rounded-lg bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition",
                                                onClick: (function (param) {
                                                    Js_promise.then_((function (param) {
                                                            console.log("Copied to clipboard");
                                                            return Promise.resolve();
                                                          }), navigator.clipboard.writeText(link));
                                                  })
                                              }),
                                          className: "flex justify-end space-x-3 border-t border-gray-200 pt-5 mt-4"
                                        })
                                  ]
                                }) : JsxRuntime.jsx("p", {
                                  children: "No link available.",
                                  className: "text-gray-600 text-center py-6"
                                })
                        )
                    ],
                    className: "relative bg-white w-full max-w-lg rounded-2xl border border-gray-100 p-8 overflow-hidden transition-all duration-200 text-center"
                  }),
              className: "fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-40 backdrop-blur-sm"
            });
}

var make = ShareDialog;

exports.make = make;
/* react Not a pure module */
